<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/card.webp"
  >
    <ng-container i18n
      >Automatically keep guests informed as their security deposit moves through each stage, from creation to release,
      with configurable notifications for every major event.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when a security deposit is</h6>
      <div class="btn-group flex-wrap">
        <button
          type="button"
          (click)="onSelectEvent(events.SecurityDepositCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.SecurityDepositCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Created
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.SecurityDepositAuthorized)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.SecurityDepositAuthorized ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Authorized
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.SecurityDepositCaptured)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.SecurityDepositCaptured ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Captured
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.SecurityDepositRefunded)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.SecurityDepositRefunded ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Refunded
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.SecurityDepositCanceled)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.SecurityDepositCanceled ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Canceled
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.SecurityDepositCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template
          *ngSwitchCase="events.SecurityDepositAuthorized"
          [ngTemplateOutlet]="authorizedEvent"
        ></ng-template>
        <ng-template *ngSwitchCase="events.SecurityDepositCaptured" [ngTemplateOutlet]="capturedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.SecurityDepositRefunded" [ngTemplateOutlet]="refundedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.SecurityDepositCanceled" [ngTemplateOutlet]="canceledEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
      <app-automation-channel-rental-select [form]="form"></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when a security deposit is</div>
    <div i18n>Last Updated Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Authorized</h6>
    <ng-template [ngTemplateOutlet]="authorizedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Captured</h6>
    <ng-template [ngTemplateOutlet]="capturedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Refunded</h6>
    <ng-template [ngTemplateOutlet]="refundedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Canceled</h6>
    <ng-template [ngTemplateOutlet]="canceledEvent"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <app-notify-guest-automation
    [event]="events.SecurityDepositCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify Guest"
    name="Notify guest when security deposit is created"
    [messageSubject]="guestNotificationMessages[events.SecurityDepositCreated].subject"
    [messageBody]="guestNotificationMessages[events.SecurityDepositCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>
</ng-template>

<ng-template #authorizedEvent>
  <app-notify-guest-automation
    [event]="events.SecurityDepositAuthorized"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify Guest funds held"
    name="Notify guest when security deposit is authorized"
    [messageSubject]="guestNotificationMessages[events.SecurityDepositAuthorized].subject"
    [messageBody]="guestNotificationMessages[events.SecurityDepositAuthorized].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>
</ng-template>

<ng-template #capturedEvent>
  <app-notify-guest-automation
    [event]="events.SecurityDepositCaptured"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify Guest funds charged"
    name="Notify guest when security deposit is captured"
    [messageSubject]="guestNotificationMessages[events.SecurityDepositCaptured].subject"
    [messageBody]="guestNotificationMessages[events.SecurityDepositCaptured].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>
</ng-template>

<ng-template #refundedEvent>
  <app-notify-guest-automation
    [event]="events.SecurityDepositRefunded"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify Guest refund processed"
    name="Notify guest when security deposit is refunded"
    [messageSubject]="guestNotificationMessages[events.SecurityDepositRefunded].subject"
    [messageBody]="guestNotificationMessages[events.SecurityDepositRefunded].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>
</ng-template>

<ng-template #canceledEvent>
  <app-notify-guest-automation
    [event]="events.SecurityDepositCanceled"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify Guest authorization released"
    name="Notify guest when security deposit is canceled"
    [messageSubject]="guestNotificationMessages[events.SecurityDepositCanceled].subject"
    [messageBody]="guestNotificationMessages[events.SecurityDepositCanceled].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>
</ng-template>
